const datasetDatasourceActions = {
  CLOSE_DATASOURCE_SETTINGS: 'CLOSE_DATASOURCE_SETTINGS',
  FETCH_DATASOURCE_SETTINGS: 'FETCH_DATASOURCE_SETTINGS',
  FETCH_DATASOURCE_SETTINGS_ERROR: 'FETCH_DATASOURCE_SETTINGS_ERROR',
  FETCH_DATASOURCE_SETTINGS_SUCCESS: 'FETCH_DATASOURCE_SETTINGS_SUCCESS',
  FETCH_DATASOURCE_TYPES: 'FETCH_DATASOURCE_TYPES',
  FETCH_DATASOURCE_TYPES_ERROR: 'FETCH_DATASOURCE_TYPES_ERROR',
  FETCH_DATASOURCE_TYPES_SUCCESS: 'FETCH_DATASOURCE_TYPES_SUCCESS',
  HIDE_DATASOURCE_SETTINGS: 'HIDE_DATASOURCE_SETTINGS',
  INITIALISE_DATASOURCE_SETTINGS: 'INITIALISE_DATASOURCE_SETTINGS',
  REMOVE_DATASOURCE_SETTINGS: 'REMOVE_DATASOURCE_SETTINGS',
  SAVE_DATASOURCE_SETTINGS: 'SAVE_DATASOURCE_SETTINGS',
  SAVE_DATASOURCE_SETTINGS_ERROR: 'SAVE_DATASOURCE_SETTINGS_ERROR',
  SAVE_DATASOURCE_SETTINGS_SUCCESS: 'SAVE_DATASOURCE_SETTINGS_SUCCESS',
  SAVE_DATASOURCE_WIZARD_ERROR: 'SAVE_DATASOURCE_WIZARD_ERROR',
  SAVE_DATASOURCE_WIZARD_SUCCESS: 'SAVE_DATASOURCE_WIZARD_SUCCESS',
  SHOW_DATASOURCE_SETTINGS: 'SHOW_DATASOURCE_SETTINGS',
  TEST_DATASOURCE_SETTINGS: 'TEST_DATASOURCE_SETTINGS',
  TEST_DATASOURCE_SETTINGS_ERROR: 'TEST_DATASOURCE_SETTINGS_ERROR',
  TEST_DATASOURCE_SETTINGS_SUCCESS: 'TEST_DATASOURCE_SETTINGS_SUCCESS',
  UPDATE_DATASOURCE_SETTINGS: 'UPDATE_DATASOURCE_SETTINGS',
};

export const datasetDatasourceFeatureActions = {
  FETCH_DATASOURCE_FEATURES: 'FETCH_DATASOURCE_FEATURES',
  FETCH_DATASOURCE_FEATURES_ERROR: 'FETCH_DATASOURCE_FEATURES_ERROR',
  FETCH_DATASOURCE_FEATURES_SUCCESS: 'FETCH_DATASOURCE_FEATURES_SUCCESS',
};

// Ordered by least to most permissive
export const datasourceFeatureStatuses = {
  UNSUPPORTED: 'unsupported',
  DISABLED: 'disabled',
  ENABLED: 'enabled',
};

export const externalDatasourceTypes = {
  POSTGRES: 'postgres',
  SQL_SERVER: 'sql_server',
  SYNAPSE: 'synapse',
  FEDERATED_NODE: 'federated_node',
};

export const datasourceTypes = {
  INTERNAL: 'internal',
  ...externalDatasourceTypes,
};

export const internalDatasourceType = {
  code: 'internal',
  enabled: true,
};

export const datasourceTypePorts = {
  postgres: 5432,
  sql_server: 1433,
  synapse: 1433,
  federated_node: 443,
};

export const datasourceFeatureCategories = {
  INGEST: 'ingest',
  MANAGEMENT: 'management',
  COHORT: 'cohort',
  TRANSFER: 'transfer',
};

export const datasourceIngestFeatures = {
  CSV: 'csv',
};

export const datasourceManagementFeatures = {
  VALIDATE: 'validate',
  CONVERT: 'convert',
};

export const datasourceTransferFeatures = {
  CLEAR: 'clear',
  PMN: 'pseudonymised',
  MANUAL: 'manual',
  TOKEN: 'token',
};

export const datasourceCohortFeatures = {
  FILTER: 'filter',
  COUNTS: 'counts',
  BOX_PLOT: 'box_plot',
  STACKED_BAR: 'stacked_bar',
  BAR: 'bar',
  HISTOGRAM: 'histogram',
};

export const tokenDatasources = [externalDatasourceTypes.FEDERATED_NODE];

export const datasetDatasourceFeaturesCategories = ['open'];
export const datasetDatasourceSettingsCategories = ['open'];

export default datasetDatasourceActions;
